var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1107",
    "data-name": "Group 1107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.485,
    height: 22.55,
    viewBox: "0 0 9.485 22.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M37.422,33.4H32.063A2.064,2.064,0,0,0,30,35.463v4.719a1.827,1.827,0,0,0,1.826,1.826v4.7a1.913,1.913,0,0,0,1.921,1.921h1.992A1.913,1.913,0,0,0,37.659,46.7v-4.7a1.842,1.842,0,0,0,1.826-1.826V35.439A2.075,2.075,0,0,0,37.422,33.4Z",
    transform: "translate(-30 -26.073)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 3.201,
    cy: 3.201,
    r: 3.201,
    transform: "translate(1.541 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.8c430e20f2be03ce99febc3f1bac75fd.svg";
export { ForwardRef as ReactComponent };